import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ProposalStatus } from 'src/app/services/api/proposal-status';
import { ProposalStatusService } from 'src/app/services/api/proposal-status.service';
import { HelpersService } from 'src/app/services/shared/helper.service';
import { ProgressBarService } from 'src/app/services/shared/progress-bar.service';
import { BasePageComponent } from 'src/app/shared/classes/base-page';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-proposal-status',
  templateUrl: './proposal-status.component.html',
  styleUrls: ['./proposal-status.component.scss']
})
export class ProposalStatusComponent extends BasePageComponent<ProposalStatus> {

  form: FormGroup;
  id: any;
 
  constructor(
    public helper: HelpersService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public service: ProposalStatusService,
    public loading: ProgressBarService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ProposalStatusComponent>,
    private fb: FormBuilder
  ) {
    super(helper, router, activatedRoute, dialog, service, loading);
    this.displayedColumns = ['no', 'label', 'action'];
    this.primaryKey = 'id';
    this.sortActive = 'label';
    this.sortDirection = 'asc';
    this.subject = 'label';
    this.search = 'label';
    this.q.sort = this.helper.parseSort(this.sortActive, this.sortDirection);
    this.form = this.fb.group({
      label: [null, Validators.required]
    })
  }

  onSave(): void {
    if (!this.id) {
      this.service.insert(this.form.value)
        .then(data => {
          this.service.getAll();
          this.loading.hide();
          this.form.reset();
        })
    } else {
      this.service.updateById(this.id, this.form.value)
        .then(data => {
          this.form.reset();
          this.id = null;
        })
    }
  }

  editData(data: any): void {
    this.form.patchValue(data);
    this.id = data.id;
  }

  deleteData(id: any): void {
    this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
    })
    .afterClosed()
    .subscribe((result) => {
      if (result) {
        this.service.removeById(id)
        .then(
          () => this.onDeleteSuccess('(' + this.transformSubject(id) + ')'),
          (err) => this.onDeleteFail(err)
        )
      }
    })
  }
  
  onConfirm(): void {
    this.dialogRef.close(true);
  }
 
  onDismiss(): void {
    this.dialogRef.close(false);
  }

}
